import Loadable from 'react-loadable';

import { LoadingPage } from 'src/components/react-loadable';

export const ProjectSettingsAccessTokensLoadable = Loadable<any, never>({
  loading: LoadingPage,
  loader: () => import('./access-tokens'),
});
